import { useRef } from "react";
import { motion } from "framer-motion";
import "../css/Subsidiaries.css";

interface Logo {
    src: string;
    alt: string;
    link?: string; // Added link property
}

interface MarqueeProps {
    speed?: number;
}

const logos: Logo[] = [
    { src: "assets/images/sinet.png", alt: "SINET", link: "https://www.sinet.com.kh" },
    // { src: "assets/images/bdc_logo.png", alt: "BDC", link: "" },
    { src: "assets/images/ananda.png", alt: "Ananda Eco Park", link: "https://anandaecopark.com" },
    { src: "assets/images/cdc.png", alt: "CDC", link: "https://www.chaktomuk-dc.com.kh" },
    { src: "assets/images/sayon.png", alt: "SAYON", link: "https://property.sayon.com.kh" },
];

const Marquee: React.FC<MarqueeProps> = ({ speed = 10 }) => {
    const marqueeRef = useRef<HTMLDivElement>(null);

    // Create repeated logos for smooth looping
    const repeatedLogos = [...logos, ...logos, ...logos, ...logos, ...logos, ...logos, ...logos, ...logos];

    return (
        <motion.section
            className="marquee-section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.1 }}
        >
            <h2>Our Subsidiaries</h2>
            <p>
                At Sayon, we take pride in our diverse portfolio of subsidiaries, each
                excelling across a range of industries. Strategically positioned to
                capitalize on market opportunities, our subsidiaries are committed to
                delivering exceptional value and driving sustainable growth.
            </p>

            <div className="marquee-wrapper">
                <div className="marquee-overlay marquee-overlay-left"></div>
                <div className="marquee-overlay marquee-overlay-right"></div>
                <div className="marquee-container">
                    <div
                        ref={marqueeRef}
                        className="marquee-content"
                        style={{ animationDuration: `${speed}s` }}
                    >
                        {repeatedLogos.map((logo, index) => (
                            <a key={`logo-${index}`} href={logo.link}  target="_blank" rel="noopener noreferrer" onClick={(e) => {
                                if (!logo.link) e.preventDefault();
                              }}>
                                <img
                                    src={logo.src}
                                    alt={logo.alt}
                                    className="marquee-logo"
                                    // style={logo.src.endsWith("cdc.png") ? { width: '250px' } : undefined}
                                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                                        e.currentTarget.style.display = "none";
                                    }}
                                />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </motion.section>
    );
};

export default Marquee;
